import { ThreeApp } from "../work-modules/007/stansEng3D.js";

window.addEventListener(
  "DOMContentLoaded",
  async () => {
    const canvas: HTMLCanvasElement | null = document.querySelector("#stansEng3D");
    if (!canvas) {
      console.error("canvas not found");
      return;
    }
    const app = new ThreeApp(canvas);

    // シーンを初期化
    app.init();

    // GLTFモデルを読み込み
    await app.load();

    // モデルをシーンに追加
    app.setupModel();

    // レンダリング開始
    app.render();
  },
  false
);
